import React from "react";

const MetadataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <>
      <JsonLd />
      {children}
    </>
  );
};

const JsonLd: React.FC = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Scale to Zero AWS Kit",
    alternateName: "AWS Serverless Solution",
    description:
      "Build production-ready AWS serverless applications with frontend, backend and complete infrastructure in one kit. Deploy in minutes using AWS best practices, reduce costs with scale-to-zero architecture.",
    applicationCategory: "DeveloperApplication, CloudApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "180",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "5",
      ratingCount: "15",
    },
    author: {
      "@type": "Person",
      name: "Scale to Zero AWS Team",
    },
    publisher: {
      "@type": "Organization",
      name: "Scale to Zero AWS",
      logo: {
        "@type": "ImageObject",
        url: "https://scaletozeroaws.com/scaletozeroaws.png",
      },
    },
    featureList: [
      "Separate production and development AWS accounts",
      "Email marketing with AWS SES",
      "Seamless integrations with Stripe",
      "Authentication and authorization using AWS Cognito",
      "Cost efficiency by scaling resources to zero when not in use",
      "AWS best practices for serverless architecture",
      "Generous free tiers usage",
    ],
    keywords:
      "scale to zero aws kit, aws serverless kit, serverless infrastructure, aws lambda starter, production-ready aws, serverless web application, frontend backend aws, aws cost efficiency, serverless authentication",
  };

  const productJsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Scale to Zero AWS Kit",
    description:
      "Build production-ready AWS serverless applications with frontend, backend and complete infrastructure in one kit.",
    image: "https://scaletozeroaws.com/scaletozeroaws.png",
    brand: {
      "@type": "Brand",
      name: "Scale to Zero AWS",
    },
    offers: [
      {
        "@type": "Offer",
        name: "Basic Plan",
        price: "180",
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        description:
          "Best for very experienced developers who do not need support at all",
      },
      {
        "@type": "Offer",
        name: "Gold Plan",
        price: "220",
        priceCurrency: "USD",
        availability: "https://schema.org/InStock",
        description:
          "Best for individuals, indie hackers, and small teams (up to 10)",
      },
    ],
    review: {
      "@type": "Review",
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5",
        bestRating: "5",
      },
      author: {
        "@type": "Person",
        name: "Verified Customer",
      },
      reviewBody: "Great kit, easy to use. Saved me a lot of time.",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(productJsonLd) }}
      />
    </>
  );
};

export default MetadataProvider;
